import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {Stock} from "../../../shared/view-model/stock";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Product} from "../../../shared/view-model/store-management/product.type";
import {Packing} from "../../../shared/view-model/store-management/packing.type";

@Component({
    selector: 'vb-add-stock-to-cart',
    templateUrl: './add-stock-to-cart.component.html',
    styleUrls: ['./add-stock-to-cart.component.css']
})
export class AddStockToCartComponent extends AbstractVisbosComponent implements OnInit {

    private _stock: Stock;

    stockItem$: ApolloQueryObservable<StockItem>;
    stockItem: StockItem;

    selectedProduct: Product;
    selectedPacking: Packing;

    stockCartForm: FormGroup;

    @Input()
    set stock(value: Stock) {
        this._stock = value;

        if (value) {
            this.stockItem$ = this.stockItemService.getStockItem(this._stock.stock_item.cuid);

            this.dataSubscriptions.push(this.stockItem$.subscribe((res: any) => {
                    this.stockItem = res;
                })
            );
        }

        this.selectedProduct = undefined;

        this.initForm();
    }

    get stock(): Stock {
        return this._stock;
    }

    constructor(sessionActions: SessionActions, private stockItemService: StockItemService, private fb: FormBuilder, cd: ChangeDetectorRef) {
        super(sessionActions, cd);
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.stockCartForm = this.fb.group({
            stock_cuid: [this.stock ? this.stock.cuid : null, Validators.required],
            product_cuid: [null, Validators.required],
            product_packing_cuid: [null, Validators.required]
        });
        this.stockCartForm.get('product_packing_cuid').disable();
    }

    onProductSelected(product: Product) {
        this.selectedProduct = product;
        this.stockCartForm.get('product_packing_cuid').enable();
    }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/add-stock-to-cart/add-stock-to-cart.component.ts